import React, { useContext, useEffect, useState } from 'react';
import {
  ClientDataSearchColumn, ClientDataSearchError, ClientDataButtoCalculate, ClientDataAddButton, ClientDataButtoCalculateButton,
  ClientDataTotal, ClientDataTotalPrice, ClientDataTotalTitle, ClientDataMontoTotal, ClientDataTotalData, ClientDataTotalDataMin,
  ClientDataTotalDataMinBlack, InfoCircleImage, Tooltip, TooltipContent, TooltipTitle, ClientDataHead, ClientDataHeadLabel, SimulatorConteinerButton, SimulatorSubSelectOficeLabelBlack
} from './styles';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { SessionContext, AgileSimulatorContext, HabeasDataSenderContext } from '../../../store';
import { Form, FormFooter, FormFooterRigth, FormRow } from '../../../components/FormTemplate/styles';
import Select from '../../../components/Select';
import InputIntl from '../../../components/InputIntl';
import { currencyMoney } from '../../../config/currency';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { StepFourDisplayValuesRow, StepFourDisplayValuesRowValue } from '../../Simulator/Result/styles';
import { StepFourColumn, StepFourDisplayValues, StepFourDisplayResultLabel } from './styles';
import { formatPrice } from '../../../helpers/price';
import { getAgileSimulatorCreditBound, getAgileSimulatorTasas, postAgileSimulatorResult } from '../../../services/agileSimulator';
import infoCircle from '../../../assets/images/info-circle.svg';
import InputDefault from '../../../components/InputDefault';
import Loader from '../../../components/Loader';
import ModalInfo from '../../../components/ModalInfo';
import { BsExclamation, BsCheck } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import { Container, ContainerSinMargen, SimulatorSelectCaminoCedulaLabelBlack, SimulatorSelectOfficeImg, SimulatorSelectOficeLabel, SimulatorSelectOficeLabelBlack } from '../styles';
import SelectOfficeImg from '../../../assets/images/SelectOfficeImg.svg'
import InputPhone from '../../../components/InputPhone';
import { default as HabeasDataSenderTypes } from '../../../store/HabeasDataSender/types';
import InputFileBackGroundImage from "../../../components/InputFileBackGroundImage";
import { useDropzone } from 'react-dropzone';
import FormTemplate from "../../../components/FormTemplate";
import { habeasDataSenderSteps } from '../../../helpers/enum';
import { enviarNotificacionCedulaHabeasData, enviarNotificacionHabeasData, getCedulaData, getObligatorieadadImagenesCedula } from '../../../services/habeasData';
import ModalActionSendIdValidation from '../../../components/ModalActionSendIdValidation';
import { useHistory } from 'react-router-dom';
import { toBase64 } from '../../../helpers/base64';
import ModalInfoImage from '../../../components/ModalInfoImage';
import descripcionCedula from '../../../assets/images/descripcionCargaCedula.svg';
import habeasdataImage from '../../../assets/images/modal-habeas-data.png'

const HabeasDataIdentityForm = ({ setActiveStep, setLastStep }) => {
  const history = useHistory();
  const { habeasDataSender, setHabeasDataSender } = useContext(HabeasDataSenderContext);
  const session = useContext(SessionContext);
  const { register, handleSubmit, setValue, watch, control, clearErrors, errors } = useForm({});
  const fields = watch();
  const [isLoading, setIsLoading] = useState(false);
  const [showModalInfoError, setShowModalInfoError] = useState(false);
  const [titleError, setTitleError] = useState('');
  const [messageError, setMessageError] = useState('');
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const [canAddFile, setCanAddFile] = useState(false);
  const [showModalNotificacion, setShowModalNotificacion] = useState(false);
  const [messageModalNotificacion, setMessageModalNotificacion] = useState('');
  const [showModalNotificacionError, setShowModalNotificacionError] = useState(false);
  const [showModalInfoCedula, setShowModalInfoCedula] = useState(false);

  async function calculateData(dataa) {
    let clientInformation;
    try {
      setIsLoading(true);
      habeasDataSender.dataCedula = false;
      if (habeasDataSender.identityPhoto[0] && habeasDataSender.identityPhoto[1]) {
        const req = new FormData();
        req.append('archivoIdentificacion1', habeasDataSender.identityPhoto[0]);
        req.append('archivoIdentificacion2', habeasDataSender.identityPhoto[1]);
        clientInformation = await getCedulaData(req);
        const statusCode = Number(clientInformation.status);
        if (statusCode == 400) {
          setMessageError(clientInformation.data);
          setShowModalInfoError(true);
          setIsLoading(false);
          return
        }
        
      setHabeasDataSender({
        type: HabeasDataSenderTypes.SET_CLIENT_DATA,
        clientData: clientInformation.data
      })

      setHabeasDataSender({
        type: HabeasDataSenderTypes.SET_JSON_RESPONSE,
        jsonResponse: clientInformation.data
      })
        //habeasDataSender.dataCedula = true;
      } /*else {
        setMessageError('Es obligatorio cargar las imagenes de la cedula');
        setShowModalInfoError(true);
        setIsLoading(false);
        return
      }*/


      setActiveStep(habeasDataSenderSteps.CONTACT_FORM)
      setLastStep(habeasDataSenderSteps.IDENTIFICATION_FORM)
      setIsLoading(false);
    } catch (error) {
      console.log(error)
      setIsLoading(false);
    }

  }

  function onDrop(file) {
    if (file[0].size / Math.pow(1024, 2) > 40) {
      setMessageError('El archivo debe ser menor a 40 mb');
      setShowModalInfoError(true);
    } else {
      if (habeasDataSender.identityPhoto.length <= 1) {
        setCanAddFile(true);
        setHabeasDataSender({
          type: HabeasDataSenderTypes.ADD_IDENTITY_PHOTO_FILE,
          file
        })
      } else {
        setCanAddFile(false);
      }
    }
  }

  function removeFile(key) {
    const file = habeasDataSender.identityPhoto.filter(
      (value, index) => index !== key
    );
    setHabeasDataSender({
      type: HabeasDataSenderTypes.REMOVE_IDENTITY_PHOTO_FILE,
      file,
    });
    setCanAddFile(true);
  }

  async function initializeStateComponent() {
    try {
      //setShowModalInfoCedula(true)
      habeasDataSender.identityPhoto.length <= 1 ? setCanAddFile(true) : setCanAddFile(false);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    initializeStateComponent();
  }, [])

  function setBackStep() {
    setActiveStep(habeasDataSenderSteps.CONTACT_FORM);
  }

  return (
    <div style={{ padding: '40px', paddingTop: '0px' }}>
      <SimulatorSelectCaminoCedulaLabelBlack style={{fontSize: 28, lineHeight:1.5,textIndent: 0}}>
        <b style={{color:colors.bgSuccess}}>Para este paso tienes 2 alternativas. ¡Tú eliges!</b>
      </SimulatorSelectCaminoCedulaLabelBlack>
      <FormRow col='2'>
        <div style={{ padding: '40px', paddingTop: '0px', border: '2px solid black', borderRadius: '10px', borderColor:colors.darkblue}}>
          <Form onSubmit={handleSubmit(calculateData)}>
            <div style={{width: '100%'}}>
              <SimulatorSelectCaminoCedulaLabelBlack style={{fontSize: 20, lineHeight:1.5,textIndent: 0}}>
                <b style={{color:colors.darkblue}}>Opción 1:  Captura los datos de la cédula manualmente</b>
              </SimulatorSelectCaminoCedulaLabelBlack>
              <SimulatorSelectCaminoCedulaLabelBlack style={{fontSize: 18, lineHeight:1.5,textIndent: 0, textAlign: 'justify'}}>
                Si eres de los que te gusta estar seguro al 100% de lo que escribes, puedes ingresar uno a uno los datos de la cédula de tu cliente de manera manual,
                <b> no olvides que debes cargar o subir la imagen de la cédula en la etapa de registro cliente.</b>
              </SimulatorSelectCaminoCedulaLabelBlack>
              <FormFooter justify="space-between">
                <SecondaryLargeButton
                  type="submit"
                  disabled={(habeasDataSender.identityPhoto[0] && habeasDataSender.identityPhoto[1])}>
                  Ingresa datos manualmente
                </SecondaryLargeButton>
              </FormFooter>
            </div>
            {isLoading && <Loader></Loader>}
            <ModalInfo
              open={showModalInfoError}
              setShowModal={setShowModalInfoError}
              title={titleError}
              description={messageError}
              backgroundIcon={colors.bgDanger}
              bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />

          </Form>
          <ModalActionSendIdValidation
            open={showModalNotificacion}
            actionFunctionDownButton={() => history.push('/admin/send-habeas')}
            actionLabelFunctionDownButton="Continuar"
            description={messageModalNotificacion}
            bodyIcon={<BsCheck id="message" size={32} color={colors.white} />}
            backgroundIcon={colors.textHyperlink} />
          <ModalActionSendIdValidation
            open={showModalNotificacionError}
            actionFunctionDownButton={() => setShowModalNotificacionError(false)}
            actionLabelFunctionDownButton="Continuar"
            description={messageModalNotificacion}
            bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
            backgroundIcon={colors.bgDanger} />
          <ModalInfoImage
            open={showModalInfoCedula}
            setShowModal={() => setShowModalInfoCedula(false)}
            description={messageModalNotificacion}
            bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
            backgroundIcon={colors.bgDanger}
            imgSource={habeasdataImage}
          />
        </div>
        <div style={{ padding: '40px', paddingTop: '0px', border: '2px solid black', borderRadius: '10px', borderColor:colors.darkblue}}>
          <SimulatorSelectCaminoCedulaLabelBlack style={{fontSize: 20, lineHeight:1.5,textIndent: 0}}>
            <b style={{color:colors.darkblue}}>Opción 2: Captura los datos de la cédula automáticamente</b> 
          </SimulatorSelectCaminoCedulaLabelBlack>
          <SimulatorSelectCaminoCedulaLabelBlack style={{fontSize: 18, lineHeight:1.5,textIndent: 0, textAlign: 'justify'}}>
            Sube la imagen de la cédula y se precargarán automáticamente los datos del cliente, agilizando el proceso y garantizando la información. Valoramos tu tiempo.
          </SimulatorSelectCaminoCedulaLabelBlack>
          <br/>
          <br/>
          <img src={descripcionCedula} style={{maxWidth: '80vh'}}></img>
          <br/>
          <br/>
          <FormTemplate
            idForm="identity-photo-step-page"
            activeStep="1/2"
            stepLabel="Precarga los datos automáticamente"
          >
            <Form onSubmit={handleSubmit(calculateData)}>
                {/* 
          <SimulatorSelectOfficeImg src={SelectOfficeImg}></SimulatorSelectOfficeImg>
          <SimulatorSelectOficeLabel>Autorización de tratamiento de datos personales</SimulatorSelectOficeLabel>
          <SimulatorSelectOficeLabelBlack>Para iniciar el proceso de autorización, por favor envíe notificación</SimulatorSelectOficeLabelBlack>
          */}
                <div style={{width: '100%'}}>
                  <InputFileBackGroundImage
                    getInputProps={getInputProps}
                    getRootProps={getRootProps}
                    canAddFile={canAddFile}
                    //selectedFile={clientRegistration.identityPhoto}
                    files={habeasDataSender.identityPhoto}
                    removeFile={removeFile}
                    description="Sube la cédula del cliente en cualquiera de los siguientes formatos PNG, JPG, JPGE, PDF o arrastra aquí"
                  />
                  <br></br>
                  <FormFooter justify="space-between">
                    <SecondaryLargeButton
                      type="submit"
                      disabled={!(habeasDataSender.identityPhoto[0] && habeasDataSender.identityPhoto[1])}>
                      Siguiente
                    </SecondaryLargeButton>
                  </FormFooter>
                </div>
              {isLoading && <Loader></Loader>}
              <ModalInfo
                open={showModalInfoError}
                setShowModal={setShowModalInfoError}
                title={titleError}
                description={messageError}
                backgroundIcon={colors.bgDanger}
                bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />

            </Form>
          </FormTemplate>
        </div>
      </FormRow>
    </div>
  )
}

export default HabeasDataIdentityForm
